import compact from "lodash/compact";
import { useTranslation } from "react-i18next";
import { FCC } from "types";

import { ActionNotPossibleContent } from "@/components/Interface/HintTooltip/ActionNotPossibleContent";
import { HintTooltip } from "@/components/Interface/HintTooltip/HintTooltip";
import { SimCardDetailNetworkResetNotAllowedReasonsItem } from "@/services/model";
import { NamespaceKey } from "@/utils/translationKey";

const reasonKey: Partial<
  Record<
    SimCardDetailNetworkResetNotAllowedReasonsItem,
    NamespaceKey<
      "portal",
      "cockpit.managementTile.details.sections.details.networkReset.reasons"
    >
  >
> = {
  [SimCardDetailNetworkResetNotAllowedReasonsItem.SIM_LOCKED]: "simLocked",
  [SimCardDetailNetworkResetNotAllowedReasonsItem.SIM_CANCELLED]:
    "simCancelled",
  [SimCardDetailNetworkResetNotAllowedReasonsItem.SIM_TERMINATED]:
    "simTerminated",
  [SimCardDetailNetworkResetNotAllowedReasonsItem.SIM_INACTIVE]: "simInactive",
  [SimCardDetailNetworkResetNotAllowedReasonsItem.OPEN_ONP]: "openONP",
  [SimCardDetailNetworkResetNotAllowedReasonsItem.OPEN_ORDER]: "openOrder",
  [SimCardDetailNetworkResetNotAllowedReasonsItem.OPEN_SPEED_AND_LOCK]:
    "openSpeedAndLock",
  [SimCardDetailNetworkResetNotAllowedReasonsItem.OPEN_NETWORK_RESET]:
    "openNetworkReset",
  [SimCardDetailNetworkResetNotAllowedReasonsItem.OPEN_ESIM_RESET]:
    "openEsimReset",
  [SimCardDetailNetworkResetNotAllowedReasonsItem.OPEN_ESIM_CHANGE]:
    "openEsimChange",
};

interface Props {
  reasons?: SimCardDetailNetworkResetNotAllowedReasonsItem[];
  leftOnMobile?: boolean;
  dataTestId?: string;
}

export const NetworkResetDisabledTooltip: FCC<Props> = ({
  reasons = [],
  leftOnMobile,
  children,
}) => {
  const { t } = useTranslation(undefined, {
    keyPrefix:
      "cockpit.managementTile.details.sections.details.networkReset.reasons",
  });

  const translatedReasons = compact<string>(
    reasons.map((reason) =>
      reasonKey[reason] ? t(reasonKey[reason]) : undefined,
    ),
  );

  return (
    <HintTooltip
      dataTestid="network-reset-disabled-tooltip"
      align={leftOnMobile ? "right" : "left"}
      content={<ActionNotPossibleContent reasons={translatedReasons} />}
    >
      {children}
    </HintTooltip>
  );
};
